import { render, staticRenderFns } from "./InfoAudience.vue?vue&type=template&id=4b89b7fe&scoped=true&"
import script from "./InfoAudience.vue?vue&type=script&lang=js&"
export * from "./InfoAudience.vue?vue&type=script&lang=js&"
import style0 from "./InfoAudience.vue?vue&type=style&index=0&id=4b89b7fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b89b7fe",
  null
  
)

export default component.exports